import { FunctionComponent } from "react";
import Proposal from "pages/Proposal/Proposal";
import { UnauthorizedPage } from "pages/UnauthorizedPage/UnauthorizedPage";
import { NotFoundPage } from "pages/NotFoundPage/NotFoundPage";
import ProposalList from "pages/ProposalList/ProposalList";
import {
  CascoConditionsPage,
  CascoConditionEditPage,
  InsurerEditPage,
} from "pages/Settings/CascoConditions";
import { InvoicePayment } from "pages/InvoicePayment/InvoicePayment";
import { InvoicePaymentVerification } from "pages/InvoicePayment/InvoicePaymentVerification";

const getOfferDetailPath = (offerId: number) => `/offer/${offerId}`;

type RouteDef = {
  key: RouteKey;
  path: string;
  element: FunctionComponent<any>;
  pathFn: ({ params }) => string;
};

type Routes = {
  offer: RouteDef;
  offers: RouteDef;
  offerDetail: RouteDef;
  unauthorizedPage: RouteDef;
  notFoundPage: RouteDef;
  cascoConditions: RouteDef;
  cascoConditionEdit: RouteDef;
  insurerEdit: RouteDef;
  invoicePayment: RouteDef;
  creditCardVerification: RouteDef;
  bankPaymentVerification: RouteDef;
};

export type RouteKey = keyof Routes;

export const routes: Routes = {
  offer: {
    key: "offer",
    path: "/offer",
    element: Proposal,
    pathFn: ({ params }: { params: {} }) => "/offer",
  },
  offers: {
    key: "offers",
    path: "/",
    element: ProposalList,
    pathFn: ({ params }: { params: {} }) => "/",
  },
  offerDetail: {
    key: "offerDetail",
    path: "/offer/:offerId",
    element: Proposal,
    pathFn: ({ params }: { params: { offerId: number } }) =>
      getOfferDetailPath(params.offerId),
  },
  unauthorizedPage: {
    key: "unauthorizedPage",
    path: "/unauthorized",
    element: UnauthorizedPage,
    pathFn: ({ params }: { params: {} }) => "/unauthorized",
  },
  notFoundPage: {
    key: "notFoundPage",
    path: "/not-found",
    element: NotFoundPage,
    pathFn: ({ params }: { params: {} }) => "/not-found",
  },
  cascoConditions: {
    key: "cascoConditions",
    path: "/settings/casco-conditions",
    element: CascoConditionsPage,
    pathFn: ({ params }: { params: {} }) => "/settings/casco-conditions",
  },
  cascoConditionEdit: {
    key: "cascoConditionEdit",
    path: "/settings/casco-conditions/:conditionId",
    element: CascoConditionEditPage,
    pathFn: ({ params }: { params: { conditionId: number } }) =>
      `/settings/casco-conditions/${params.conditionId}`,
  },
  insurerEdit: {
    key: "insurerEdit",
    path: "/settings/casco-conditions/insurer/:insurerName",
    element: InsurerEditPage,
    pathFn: ({ params }: { params: { insurerName: string } }) =>
      `/settings/casco-conditions/insurer/${params.insurerName}`,
  },
  invoicePayment: {
    key: "invoicePayment",
    path: "/invoice-payment/:offerId/:invoiceId",
    element: InvoicePayment,
    pathFn: ({ params }: { params: { offerId: string; invoiceId: string } }) =>
      `/invoice-payment/${params.offerId}/${params.invoiceId}`,
  },
  creditCardVerification: {
    key: "creditCardVerification",
    path: "/invoice-payment/verify/creditcard",
    element: InvoicePaymentVerification,
    pathFn: ({ params }: { params: {} }) =>
      "/invoice-payment/verify/creditcard",
  },
  bankPaymentVerification: {
    key: "bankPaymentVerification",
    path: "/invoice-payment/verify/bank/:bankName",
    element: InvoicePaymentVerification,
    pathFn: ({ params }: { params: { bankName: string } }) =>
      `/invoice-payment/verify/bank/${params.bankName}`,
  },
};

// export const useCurrentRoute = () => {
//   const location = useLocation();
//   return Object.values(routes).reduce((match: RouteKey | null, r) => {
//     const matchResult = r.matchPath(location);
//     if (!!matchResult) {
//       return r.key;
//     }
//     return match;
//   }, null);
// };
